import { ReviewJsEnv } from './review_js_env';
import { CarouselItem } from '../../../core/models/item';

/** ReviewJsEnvを操作する人 */
export class Review {
  constructor(private model: ReviewJsEnv) {
    this.model = { ...model };
    // rrAreaに表示するItemsとTitleは外部公開APIとRRサーバで取得するのでここは空で定義
    this.model.rrAreaProfileItemModal = {
      placementName: "recomRR_Modal_01",
      displayCount: 8,
      rrAreaItems: [],
      rrAreaTitle: "",
      perView: 5
    };
  }

  updateModel(newModel: ReviewJsEnv) {
    this.model = { ...newModel };
  }

  getModel(): ReviewJsEnv {
    return {
      ...this.model
    };
  }

  setRrAreaDataItemModal(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileItemModal.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileItemModal.rrAreaTitle = rrAreaTitle;
  }
}
